module.exports = __webpack_public_path__ + "img/66-7a296c.png";